import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

/** iOS-friendly nav/action buttons — 44px min touch target, no double-tap zoom delay. */
export const touchNavButtonSx: SystemStyleObject<Theme> = {
  minHeight: 44,
  touchAction: 'manipulation',
  WebkitTapHighlightColor: 'transparent',
  flexShrink: 0,
  position: 'relative',
  zIndex: 2,
};

/** Section header row above clickable card grids — stays above stretched-link overlays. */
export const touchNavHeaderRowSx: SystemStyleObject<Theme> = {
  position: 'relative',
  zIndex: 2,
  isolation: 'isolate',
};
